module.exports = __webpack_public_path__ + "img/orange_071.2d157fce.png";